var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_vm._v("欢迎来到今个儿简讯系统后台")])
}
var staticRenderFns = []

export { render, staticRenderFns }